import { Component, Inject, OnInit } from '@angular/core';
import {
  MatLegacyDialogRef as MatDialogRef,
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
} from '@angular/material/legacy-dialog';
import { AttributesEditorDataSource } from '../attributes-editor/attributesEditorDataSource';
import { EditableAttribute } from '../../models/attributes/editableAttribute';

@Component({
  selector: 'app-complex-field-editor',
  templateUrl: './complex-field-editor.component.html',
  styleUrls: ['./complex-field-editor.component.scss'],
})
export class ComplexFieldEditorComponent implements OnInit {
  attributesEditorDataSource = new AttributesEditorDataSource();
  complexField: EditableAttribute;
  editMode = false;
  constructor(
    public dialogRef: MatDialogRef<ComplexFieldEditorComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {
    this.complexField = this.data.attribute;
    this.editMode = this.data.attributes.length > 0;
    let subFieldAttributeDefinitions = this.complexField.subFieldList.map(
      (x) => x.subFieldDefinition
    );
    let subFields = this.complexField.subFieldList
      .filter((x) => x.required == true)
      .map((y) => y.subFieldDefinition);
    subFieldAttributeDefinitions.forEach((subField) => {
      if (subFields.includes(subField)) {
        subField.required = true;
      }
    });
    this.attributesEditorDataSource.sortOnName = false;
    this.attributesEditorDataSource.load(this.data.attributes, subFieldAttributeDefinitions);
  }

  onSave() {
    this.dialogRef.close(this.attributesEditorDataSource);
  }

  isInvalid(): boolean {
    var firstQuestionId = this.complexField.subFieldList[0].subFieldDefinitionId;
    var answers = this.attributesEditorDataSource.asAttributeWrites();
    return (
      !this.attributesEditorDataSource.isValid ||
      answers.length == 0 ||
      answers.findIndex((a) => a.attributeDefinitionId == firstQuestionId) == -1
    );
  }

  getButtonName() {
    return (this.editMode ? 'Update' : 'Add') + ' ' + this.complexField.name;
  }
}
